import ForgotPasswordView from "@/components/templates/ForgotPassword/forgot-password-view";
import { Locales } from "@/lib/i18n";
import { actions, segments } from "@/locales/segment";

export const getActionFromSlug = (locale: Locales, slug: string) => {
  const localeActions = actions[locale as keyof typeof actions];
  if (!localeActions) return null;
  return Object.keys(localeActions).find((key) => localeActions[key] === slug);
};

export const isForgotPasswordSegment = (locale: Locales, slug: string) => {
  const localeSegments = segments[locale as keyof typeof segments];
  if (!localeSegments) return false;
  return localeSegments["forgot-password"] === slug;
};

export const renderForgotPasswordView = (resolution: Resolution) => {
  const slugs = resolution.slugs;
  const currentSlug = slugs[0];

  if (isForgotPasswordSegment(resolution.locale, currentSlug)) {
    return <ForgotPasswordView resolution={resolution} />;
  }

  const action = getActionFromSlug(resolution.locale, currentSlug);

  if (!action) {
    return null;
  }

  switch (action) {
    case "verify":
      return <article>Verify</article>;
    default:
      return null;
  }
};
